function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#K)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.133 31.032L27.045 62 0 46.441.088 15.472l27.044 15.56z",
  fill: "#29394d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.133 31.033l26.867-15.559-.088 30.969-26.867 15.558.088-30.968z",
  fill: "#3c4e64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.088 15.473L26.955 0l27.044 15.474-26.866 15.559L.088 15.473z",
  fill: "#6d7f92"
}), /*#__PURE__*/React.createElement("mask", {
  id: "A",
  maskUnits: "userSpaceOnUse",
  x: 38,
  y: 20,
  width: 7,
  height: 19,
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.634 20.895l.043 13.756-6.444 3.736-.044-13.756 6.445-3.736z",
  fill: "url(#F)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#A)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.634 20.895l.043 13.756-6.444 3.736-.044-13.756 6.445-3.736z",
  fill: "#f2994a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "B",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 5,
  width: 34,
  height: 20,
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.635 20.898l-6.446 3.734-27.04-15.557 6.446-3.733 27.04 15.557z",
  fill: "url(#G)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#B)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.635 20.898l-6.446 3.734-27.04-15.557 6.446-3.733 27.04 15.557z",
  fill: "#f2994a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "C",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 40,
  width: 8,
  height: 16,
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.013 40.497l-.044 11.854 6.445 3.563.044-11.682-6.445-3.735z",
  fill: "url(#H)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#C)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.013 40.497l-.044 11.854 6.445 3.563.044-11.682-6.445-3.735z",
  fill: "#f2994a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "D",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 21,
  width: 7,
  height: 14,
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1 21.335l-.044 9.608 6.445 3.563.044-9.435-6.445-3.736z",
  fill: "url(#I)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#D)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1 21.335l-.044 9.608 6.445 3.563.044-9.435-6.445-3.736z",
  fill: "#f2994a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "E",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 5,
  width: 34,
  height: 21,
  "mask-type": "alpha"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.15 21.329l6.446 3.734 27.04-15.557-6.446-3.733-27.04 15.557z",
  fill: "url(#J)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#E)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.15 21.329l6.446 3.734 27.04-15.557-6.446-3.733-27.04 15.557z",
  fill: "#f2994a"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "F",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(41.4337 29.6405) scale(6.61627 6.59329)",
  xlinkHref: "#L"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.016,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.538,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#b3b3b3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "G",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(27.8916 14.9863) scale(13.675 13.6275)",
  xlinkHref: "#L"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.016,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.538,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "H",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(13.2127 48.2053) scale(5.93155 5.91094)",
  xlinkHref: "#L"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.016,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.538,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "I",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(13.3001 27.9208) scale(5.20555 5.18745)",
  xlinkHref: "#L"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.014,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.537,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#b3b3b3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "J",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(26.8938 15.4172) scale(13.675 13.6275)",
  xlinkHref: "#L"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.011,
  stopColor: "#666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.536,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "K"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h54v62H0z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "L",
  gradientUnits: "userSpaceOnUse"
}));

var SvgPack = function SvgPack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pack.62f62b9b.svg";
export { ForwardRef as ReactComponent };